const NOTICE_KEY = "vero.signInNotice";

export const PASSWORD_CHANGED =
  "Your password was changed. Sign in with your new password. You've been signed out on your other devices.";

/** Same path on vero.ag, diyagronomy.com, and the staging host. */
export const SIGN_IN_PATH = "/sign-in";

export function stashSignInNotice(message: string): void {
  sessionStorage.setItem(NOTICE_KEY, message);
}

export function takeSignInNotice(): string | null {
  try {
    const value = sessionStorage.getItem(NOTICE_KEY);
    if (value != null) sessionStorage.removeItem(NOTICE_KEY);
    return value;
  } catch {
    return null;
  }
}

export function goToSignIn(
  navigate: (path: string) => void = assignPath,
): void {
  navigate(SIGN_IN_PATH);
}

function assignPath(path: string): void {
  window.location.assign(path);
}
